<template>
    <!-- 商品出库申请单 -->
    <a-modal
    centered
    title="商品出库申请单"
    :visible="visible"
    :width="800"
    @cancel="visible = false"
    >
        <a-spin :spinning="spinning">
            <a-table
            bordered
            :columns="columns"
            :dataSource="detail.infoList"
            :pagination="false"
            :scroll="{y: 400}"
            class="wrap-table"
            >
                <template slot="index" slot-scope="key, row, index">
                    {{index + 1}}
                </template>
            </a-table>
            <div class="out-apply-detail-info mt16">
                <a-row class="mb16">
                    <a-col :span="24">出库仓库：{{detail.warehouseName}}</a-col>
                </a-row>
                <a-row class="mb16">
                    <a-col :span="8">申请人：{{detail.applyUserName}}</a-col>
                    <a-col :span="16">申请时间：{{detail.applyTime}}</a-col>
                </a-row>
                <a-row class="mb16">
                    <a-col :span="24">申请理由：{{detail.reason}}</a-col>
                </a-row>
                <a-row  class="mb16">
                    <a-col :span="8">审批人：{{detail.approvalUserName}}</a-col>
                    <a-col :span="16" v-if="approvalRecord.hasOwnProperty('approveState')">审批状态：{{["待审核","审核通过", "审核不通过"][detail.approveState]}}</a-col>
                    <a-col :span="16" v-else>审批状态：{{["", "", "待审核","审核通过", "审核不通过"][approvalRecord.state]}}</a-col>
                </a-row>
                <a-row :class="detail.state === 2 ? 'mb16' : ''">
                    <a-col :span="24">出库状态：{{['待出库', '出库成功', '出库失败'][detail.state]}}</a-col>
                </a-row>
                <a-row v-if="detail.state === 2">
                    <a-col :span="24">出库失败原因：{{detail.failureReasons}}</a-col>
                </a-row>
            </div>
        </a-spin>
        <template slot="footer">
            <div class="text-center">
                <template v-if="disabled || approvalRecord.state !== 2">
                    <a-button @click="visible = false">返回</a-button>
                </template>
                <template v-else>
                    <a-button @click="OAapprovalUnpass" :loading="approvalLoading">审批不通过</a-button>
                    <a-button @click="OAapprovalPass" :loading="approvalLoading" type="primary">审批通过</a-button>
                </template>
            </div>
        </template>
    </a-modal>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns = [
        {
            title: '序号',
            scopedSlots: {customRender: 'index'},
            width: '10%'
        },
        {
            title: '商品编号',
            dataIndex: 'goodsNo',
            width: '18%'
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName',
            width: '18%'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification',
            width: '18%'
        },
        {
            title: '商品分组',
            dataIndex: 'goodsCategoryName',
            width: '18%'
        },
        {
            title: '出库数量',
            dataIndex: 'outNum',
            width: '18%'
        },
    ];
    export default {
        name: 'goodsOutWarehouseApplayDetailModal',
        components: {},
        props: {
            disabled: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                columns,
                spinning: false,
                visible: false,
                detail: {
                    infoList: []
                },
                approvalId: null,
                approvalLoading: false,
                approvalRecord: {}
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            
        },
        methods: {
            /**
             * @showApplyDetail 出库审批单查看
             */
            showApplyDetail(record) {
                let { id, businessId } = record;
                this.approvalRecord = record;
                this.spinning = true;
                this.visible = true;
                this.approvalId = id;
                this.$api.newStorage.approveOutDetail({
                    params: {
                        id: businessId
                    }
                }).then(res => {
                    this.detail = res;
                    this.spinning = false;
                });
            },
            /**
             * @OAapproval {method} 审核通过提交事件
             */
            OAapprovalPass() {
                this.approvalLoading = true;
                this.$api.audit.pass({
                    body: {
                        approvalId: this.approvalId
                    }
                }).then(data => {
                    this.$message.success("操作成功");
                    this.approvalLoading = false;
                    this.visible = false;
                    if (this.$listeners.hasOwnProperty('getList')) {
                        setTimeout(() => {
                            this.$emit('getList');
                        }, 300);
                    }
                }).catch(err => {
                    this.approvalLoading = false;
                });
            },
            /**
             * @OAapprovalUnpass {method} 审核不通过提交事件
             */
            OAapprovalUnpass() {
                this.approvalLoading = true;
                this.$api.audit.unPass({
                    body: {
                        approvalId: this.approvalId
                    }
                }).then(data => {
                    this.$message.success("操作成功");
                    this.approvalLoading = false;
                    this.visible = false;
                    if (this.$listeners.hasOwnProperty('getList')) {
                        setTimeout(() => {
                            this.$emit('getList');
                        }, 300);
                    }
                }).catch(err => {
                    this.approvalLoading = false;
                });
            },
        },
        beforeCreate() {
        },
        created() {},
        mounted() {
        }
    };
</script>
<style lang="scss">
.out-apply-detail-info {
    background-color: #efefef;
    padding: 16px;
}
</style>